import Admin from "../pages/Admin";
import Enterprise from "../pages/Enterprise";
import BrandPersonality from "../pages/Enterprise/modules/BrandPersonality";
import Briefing from "../pages/Enterprise/modules/Briefing";
import EditorialTree from "../pages/Enterprise/modules/EditorialTree";
import Persona from "../pages/Enterprise/modules/Persona";
import SmartGoals from "../pages/Enterprise/modules/SmartGoals";
import Enterprises from "../pages/Enterprises";
import Login from "../pages/Login";
import SignUp from "../pages/SignUp";
import Trial from "../pages/Trial";
import Post from "../pages/Enterprise/modules/Post";

export const routeList = [
  {
    key: "route-login",
    path: "/",
    element: <Login />,
  },
  {
    key: "route-signup",
    path: "/cadastro",
    element: <SignUp />,
  },
  {
    key: "route-admin",
    path: "/admin",
    element: <Admin />,
  },
  {
    key: "route-trial",
    path: "/trial",
    element: <Trial />,
  },
  {
    key: "route-enterprises",
    path: "/empresas",
    element: <Enterprises />,
  },
  {
    key: "route-enterprise",
    path: "/empresa/:id",
    element: (
      <Enterprise>
        <SmartGoals />
      </Enterprise>
    ),
  },
  {
    key: "route-enterprise-briefing",
    path: "/empresa/:id/briefing",
    element: (
      <Enterprise>
        <Briefing />
      </Enterprise>
    ),
  },
  {
    key: "route-enterprise-target",
    path: "/empresa/:id/objetivos",
    element: (
      <Enterprise>
        <SmartGoals />
      </Enterprise>
    ),
  },
  {
    key: "route-enterprise-persona",
    path: "/empresa/:id/persona",
    element: (
      <Enterprise>
        <Persona />
      </Enterprise>
    ),
  },
  {
    key: "route-enterprise-brand-personality",
    path: "/empresa/:id/tom-e-voz",
    element: (
      <Enterprise>
        <BrandPersonality />
      </Enterprise>
    ),
  },
  {
    key: "route-enterprise-editorial",
    path: "/empresa/:id/editorial",
    element: (
      <Enterprise>
        <EditorialTree />
      </Enterprise>
    ),
  },
  {
    key: "route-enterprise-calendario",
    path: "/empresa/:id/calendario",
    element: (
      <Enterprise>
        <Post />
      </Enterprise>
    ),
  },
];
